/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Regionalpricingbadge_Analysis2Inputs */

const id_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis harga regional`)
};

const ms_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis harga wilayah`)
};

const da_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional prisanalyse`)
};

const de_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regionale Preisanalyse`)
};

const en_us2_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional pricing analysis`)
};

const es_es2_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de precios regionales`)
};

const es_mx2_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de precios regionales`)
};

const fil_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagsusuri ng regional pricing`)
};

const fr_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse des prix régionaux`)
};

const it_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi prezzi regionali`)
};

const hu_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regionális árazás elemzése`)
};

const nl_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regionale prijsanalyse`)
};

const no_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional prisanalyse`)
};

const pl_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza cen regionalnych`)
};

const pt_br2_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional pricing analysis`)
};

const pt_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise de preços regionais`)
};

const ro_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiză prețuri regionale`)
};

const fi_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alueellinen hinnoitteluanalyysi`)
};

const sv_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analys av regional prissättning`)
};

const vi_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân tích giá theo khu vực`)
};

const tr_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bölgesel fiyatlandırma analizi`)
};

const cs_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analýza regionálního oceňování`)
};

const bg_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ на регионалното ценообразуване`)
};

const ru_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ региональных цен`)
};

const uk_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аналіз регіональних цін`)
};

const ar_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليل التسعير الإقليمي`)
};

const hi_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षेत्रीय मूल्य विश्लेषण`)
};

const th_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การวิเคราะห์ราคาตามภูมิภาค`)
};

const ja_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地域価格分析`)
};

const zh_cn2_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional pricing analysis`)
};

const zh_hant1_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional pricing analysis`)
};

const ko_components_regionalpricingbadge_analysis2 = /** @type {(inputs: Components_Regionalpricingbadge_Analysis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional pricing analysis`)
};

/**
* | output |
* | --- |
* | "Regional pricing analysis" |
*
* @param {Components_Regionalpricingbadge_Analysis2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_regionalpricingbadge_analysis2 = /** @type {((inputs?: Components_Regionalpricingbadge_Analysis2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Regionalpricingbadge_Analysis2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "ms") return ms_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "da") return da_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "de") return de_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "en-US") return en_us2_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "es-ES") return es_es2_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "es-MX") return es_mx2_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "fil") return fil_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "fr") return fr_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "it") return it_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "hu") return hu_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "nl") return nl_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "no") return no_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "pl") return pl_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "pt-BR") return pt_br2_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "pt") return pt_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "ro") return ro_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "fi") return fi_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "sv") return sv_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "vi") return vi_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "tr") return tr_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "cs") return cs_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "bg") return bg_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "ru") return ru_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "uk") return uk_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "ar") return ar_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "hi") return hi_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "th") return th_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "ja") return ja_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_regionalpricingbadge_analysis2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_regionalpricingbadge_analysis2(inputs)
	return ko_components_regionalpricingbadge_analysis2(inputs)
});
export { components_regionalpricingbadge_analysis2 as "components.regionalPricingBadge.analysis" }